export const date = "РАСПРОДАЖА ЗАКОНЧЕНА";